module.exports = __webpack_public_path__ + "img/arrow-r.cbc837f4.svg";